"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fallbackCopy = exports.templateTranslationKeys = void 0;
// all possible template translation keys
exports.templateTranslationKeys = [
    'cover.title',
    'cover.body',
    'slide.title',
    'column.title',
    'slide.body',
    'column.body',
    'image.caption',
    'quiz.title',
    'openQuestion.title',
    'wordCloud.title',
];
/** We need to make sure we always have something, Storybook for instance relies on it */
exports.fallbackCopy = {
    'cover.title': 'Lesson title',
    'cover.body': 'Learning objective',
    'slide.title': 'Slide heading',
    'column.title': 'Column heading',
    'slide.body': 'Slide text',
    'column.body': 'Column text',
    'image.caption': 'Image caption',
    'quiz.title': 'Enter your question here',
    'openQuestion.title': 'Enter your question here',
    'wordCloud.title': 'Question or subject',
};
//# sourceMappingURL=template-translations.js.map